// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__QOoNW","title":"styles_title__VSJEr","description":"styles_description__Z_rBG","skeleton_animate":"styles_skeleton_animate__Yx86n"};